<template>
  <v-row align="center" class="ma-0 pa-0">
    <v-col cols="12" class="pa-0">
      <v-card flat class="ma-0 pa-0 overflow-y-auto" :style="contentsHeight + ' overflow-x: hidden;'">
        <template v-for="item in group">
          <v-row align="center" class="ma-0 pa-0" :key="item + 'header'">
            <v-col cols="12" class="pa-0 b-B">
              <v-card-title class="pb-0">{{ getName(item) }}</v-card-title>
            </v-col>
            <v-col cols="12" class="pa-0">
              <template v-if="!viewType">
                <app-metrics-enrolled
                  :key="item"
                  :groups="groups"
                  :item="item"
                  :year="year"
                  :compare="compare"
                  :indicator="indicator"
                  :headers="headers"
                  :expand="expand"
                  :items="items"
                  :plans="plans"
                  :diffs="diffs"
                  :diffsRevises="diffsRevises"
                  :revices="revices"
                  :sColor="'#00ff0030'"
                  @onValueSelect="onValueSelect"
                >
                </app-metrics-enrolled>

                <app-metrics-inout
                  :key="item + 'header2'"
                  :groups="groups"
                  :item="item"
                  :year="year"
                  :compare="compare"
                  :headers="headers2"
                  :expand="expand2"
                  :status="status"
                  :plans="plans"
                  :inout="inout"
                  :sColor="'amber'"
                  @onValueSelectStatus="onValueSelectStatus"
                >
                </app-metrics-inout>
              </template>
              <template v-else>
                <v-row align="start" justify="center" class="ma-0 pa-0">
                  <v-col cols="6" align="center">
                    <v-col cols="12" class="pa-0" align="center">
                      <template-metrics-graph
                        :type="'enrollment'"
                        :height="200"
                        :year="year"
                        :indicator="indicator"
                        :group="item"
                        :tempGroups="tempGroups"
                        :compare="compare"
                        :items="items"
                        :plans="plans"
                        :diffs="diffs"
                        :diffsRevises="diffsRevises"
                        :inout="inout"
                        :revices="revices"
                      >
                      </template-metrics-graph>
                    </v-col>
                    <v-col v-if="compare == 'N/A'" cols="12" class="pa-0">
                      <template-metrics-graph
                        :type="'io'"
                        :height="200"
                        :year="year"
                        :indicator="indicator"
                        :group="item"
                        :tempGroups="tempGroups"
                        :compare="compare"
                        :items="items"
                        :plans="plans"
                        :diffs="diffs"
                        :diffsRevises="diffsRevises"
                        :inout="inout"
                        :revices="revices"
                      >
                      </template-metrics-graph>
                    </v-col>
                  </v-col>
                  <v-col cols="6" align="center" justify="start">
                    <v-col cols="12" class="pa-0">
                      <template-metrics-graph
                        :type="'ratio'"
                        :height="200"
                        :year="year"
                        :indicator="indicator"
                        :group="item"
                        :tempGroups="tempGroups"
                        :compare="compare"
                        :items="items"
                        :plans="plans"
                        :diffs="diffs"
                        :diffsRevises="diffsRevises"
                        :inout="inout"
                        :revices="revices"
                      >
                      </template-metrics-graph>
                    </v-col>
                  </v-col>
                </v-row>
              </template>
            </v-col>
          </v-row>
        </template>
      </v-card>
    </v-col>

    <div>
      <v-dialog v-model="listDialog"
        hide-overlay
        fullscreen
        transition="dialog-bottom-transition"
        scrollable
        >
        <app-list-dialog
          v-if="listDialog"
          @dismissed="onDismissed"
          :selected="selected"
          :status="type"
        >
        </app-list-dialog>
      </v-dialog>
    </div>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

  </v-row>
</template>
<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import * as Papa from 'papaparse'
import Enrolled from './templates/Enrolled.vue'
import Inout from './templates/Inout.vue'
import ListDialog from '../../components/student/ListDialog.vue'

Vue.component('app-metrics-enrolled', Enrolled)
Vue.component('app-metrics-inout', Inout)
Vue.component('app-list-dialog', ListDialog)

export default {
  props: [ 'year', 'group', 'tempGroups', 'compare', 'indicator', 'items', 'plans', 'status', 'diffs', 'diffsRevises', 'inout', 'revices', 'viewType' ],
  data () {
    return {
      loading: false,
      listDialog: false,
      type: 1,
      item: null,
      totalsStatus: {},
      expand: [
        { key: 0, type: '', value: true, enable: false },
        { key: 17, type: '', value: true, enable: false },
        { key: 30, type: 'Y', value: true, enable: true },
        { key: 14, type: 'S', value: true, enable: true },
        { key: 15, type: 'J', value: true, enable: true },
        { key: 16, type: 'H', value: true, enable: true }
      ],
      expansions: [],
      expand2: [
        { key: 0, type: '', value: true, enable: false },
        { key: 17, type: '', value: true, enable: false },
        { key: 30, type: 'YI', value: true, enable: true },
        { key: 14, type: 'SI', value: true, enable: true },
        { key: 15, type: 'JI', value: true, enable: true },
        { key: 16, type: 'HI', value: true, enable: true }
      ],
      expansions2: [],
      selected: null
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      users: 'users/users',
      groups: 'groups/groups',
      schools: 'schools/schools',
      privilege: 'shared/privilege',
      headers: 'metricsActs/headers',
      headers2: 'metricsActs/headers2',
      preHeader: 'metricsActs/preHeader',
      preHeader2: 'metricsActs/preHeader2',
      windowSize: 'shared/windowSize',
      preschool: 'shared/preschool',
      extension: 'shared/extension'
    }),
    contentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - 60 - 40) + 'px;'
    }
  },
  watch: {
    year () {
      this.createExpansions()
    },
    group () {
      this.createExpansions()
    },
    groups () {
      this.createExpansions()
    },
    metricsPlans () {
      this.createExpansions()
    }
  },
  created () {
    this.createExpansions()
  },
  methods: {
    createExpansions () {
      this.expansions = []
      this.expansions2 = []
      if (!this.data || typeof this.data.groups === 'undefined') {
        return
      }
      if (this.getPrivilegesLevel(this.data) === 0) {
        Vue.set(this.expansions, '*', JSON.parse(JSON.stringify(this.expand)))
        Vue.set(this.expansions2, '*', JSON.parse(JSON.stringify(this.expand2)))
        for (var index in this.groups) {
          if (this.groups[index].classroom) {
            Vue.set(this.expansions, this.groups[index].key, JSON.parse(JSON.stringify(this.expand)))
            Vue.set(this.expansions2, this.groups[index].key, JSON.parse(JSON.stringify(this.expand2)))
          }
        }
      } else if (this.getPrivilegesLevel(this.data) < 3) {
        Vue.set(this.expansions, '*', JSON.parse(JSON.stringify(this.expand)))
        Vue.set(this.expansions2, '*', JSON.parse(JSON.stringify(this.expand2)))
        var keys = Object.keys(this.data.schools)
        for (index in this.groups) {
          for (var x in keys) {
            if (this.data.schools[keys[x]]) {
              if (this.groups[index].classroom) {
                if (this.groups[index].schools[keys[x]]) {
                  Vue.set(this.expansions, this.groups[index].key, JSON.parse(JSON.stringify(this.expand)))
                  Vue.set(this.expansions2, this.groups[index].key, JSON.parse(JSON.stringify(this.expand2)))
                }
              }
            }
          }
        }
      } else {
        keys = Object.keys(this.data.groups)
        for (index in this.groups) {
          for (x in keys) {
            if (this.data.groups[keys[x]]) {
              if (this.groups[index].classroom) {
                if (this.groups[index].key === keys[x]) {
                  Vue.set(this.expansions, this.groups[index].key, JSON.parse(JSON.stringify(this.expand)))
                  Vue.set(this.expansions2, this.groups[index].key, JSON.parse(JSON.stringify(this.expand2)))
                }
              }
            }
          }
        }
      }
    },
    onFileSelect (item) {
      this.item = JSON.parse(JSON.stringify(item))
      this.$refs[item][0].click()
    },
    onFileExport (item) {
      var temp = []
      var name = this.getName(item)

      const config = {
        delimiter: ',', // 区切り文字
        header: true, // キーをヘッダーとして扱う
        newline: '\n' // 改行
      }
      for (var i = 0; i < 12; i++) {
        for (var x in this.items[item][i]) {
          var v = JSON.parse(JSON.stringify(this.items[item][i][x]))
          temp.push(v)
        }
      }
      const delimiterString = Papa.unparse(temp, config)
      const blobUrl = new Blob([delimiterString], { type: 'text/csv' })
      const blob = blobUrl
      const aTag = document.createElement('a')

      aTag.download = this.year + '-' + name + '.csv'

      if (window.navigator.msSaveBlob) {
        // for IE
        window.navigator.msSaveBlob(blob, aTag.download)
      } else if (window.URL && window.URL.createObjectURL) {
        // for Firefox
        aTag.href = window.URL.createObjectURL(blob)
        document.body.appendChild(aTag)
        aTag.click()
        document.body.removeChild(aTag)
      } else if (window.webkitURL && window.webkitURL.createObject) {
        // for Chrome
        aTag.href = (window.URL || window.webkitURL).createObjectURL(blob)
        aTag.click()
      } else {
        // for Safari
        window.open(
          `data:type/csv;base64,${window.Base64.encode(this.state.content)}`,
          '_blank'
        )
      }
    },
    getName (item) {
      if (item === '*') {
        return '全校'
      }
      var index = this.groups.findIndex(group => group.key === item)
      if (index !== -1) {
        return this.groups[index].name
      }
      return ''
    },
    onDismissed: function (result) {
      this.listDialog = false
      if (result) {
        this.$nextTick(function () {
          this.onUpdate()
        })
      }
    },
    onUpdate () {
    },
    onValueSelect: function (value) {
      if (this.items[value.item][value.month - 1][value.metric.key].length !== 0) {
        this.selected = this.items[value.item][value.month - 1][value.metric.key]
        this.listDialog = true
      }
    },
    onValueSelectStatus: function (value) {
      if (this.inout[value.item][value.month - 1][value.metric.key][value.inout].length !== 0) {
        this.selected = this.inout[value.item][value.month - 1][value.metric.key][value.inout]
        this.listDialog = true
      }
    }
  }
}
</script>

<style scoped>
input[type="file"] {
  display: none;
}

span.clickable {
  cursor: pointer !important;
}
.b-B {
  border-bottom: 1px solid #1976D2 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
</style>
